var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_c('b-modal',{attrs:{"id":"auth-modal","ok-only":""},on:{"hide":_vm.routeToAuth}},[_c('p',{staticClass:"my-4"},[_vm._v("The session has expired since you have been inactive for "+_vm._s(_vm.logoutTime)+".")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }